export const despojado = {
	nombre: "Despojado",
	dia: "Domingo de Ramos",
	nombrecompleto:
		"Hermandad Salesiana de Penitencia de Nuestro Padre Jesús del Amor Despojado de sus Vestiduras y María Santísima de la Concepción",
	sede: "Iglesia de María Auxiliadora",
	pasos: 1,
	distancia: [3190, 3870],
	penitentes: 285,
	cargadores: 60,
	web: "http://www.diariodecadiz.es/semana_santa/Despojado_0_1229277791.html",

	ida: [
		{ lng: -6.2786973, lat: 36.5125249 },
		{ lng: -6.2790513, lat: 36.5123999 },
		{ lng: -6.2798882, lat: 36.5138615 },
		{ lng: -6.2801832, lat: 36.5139908 },
		{ lng: -6.2805587, lat: 36.514034 },
		{ lng: -6.2812453, lat: 36.5137882 },
		{ lng: -6.2876076, lat: 36.525036 },
		{ lng: -6.2877846, lat: 36.5255274 },
		{ lng: -6.2884015, lat: 36.5262645 },
		{ lng: -6.2888521, lat: 36.5266396 },
		{ lng: -6.2889487, lat: 36.5270232 },
		{ lng: -6.288777, lat: 36.5274069 },
		{ lng: -6.2888467, lat: 36.5277216 },
		{ lng: -6.2890935, lat: 36.5281182 },
		{ lng: -6.2895361, lat: 36.5287626 },
		{ lng: -6.2900484, lat: 36.5291247 },
		{ lng: -6.2902871, lat: 36.5291333 },
		{ lng: -6.2913066, lat: 36.5296575 },
		{ lng: -6.2921861, lat: 36.5302519 },
		{ lng: -6.2919554, lat: 36.530462 },
		{ lng: -6.2927105, lat: 36.5313209 },
		{ lng: -6.2929317, lat: 36.5316065 },
		{ lng: -6.2932375, lat: 36.53144 },
		{ lng: -6.2921967, lat: 36.5302911 },
		{ lng: -6.2928129, lat: 36.5297924 },
		{ lng: -6.293031, lat: 36.5298165 },
		{ lng: -6.2932831, lat: 36.5297411 },
		{ lng: -6.2945397, lat: 36.5296318 },
		{ lng: -6.2950882, lat: 36.5295191 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956837, lat: 36.5291139 },
		{ lng: -6.2955549, lat: 36.5294911 },
		{ lng: -6.2954088, lat: 36.5297605 },
		{ lng: -6.2956649, lat: 36.5299469 },
		{ lng: -6.2952848, lat: 36.5303552 },
		{ lng: -6.2950748, lat: 36.5307067 },
		{ lng: -6.2950252, lat: 36.5308295 },
		{ lng: -6.2949206, lat: 36.5308392 },
		{ lng: -6.2949193, lat: 36.5314513 },
		{ lng: -6.2964723, lat: 36.5317714 },
		{ lng: -6.2964039, lat: 36.5318457 },
		{ lng: -6.2967977, lat: 36.5325461 },
		{ lng: -6.2972365, lat: 36.5319356 },
		{ lng: -6.2973761, lat: 36.5315 },
		{ lng: -6.2975639, lat: 36.5310041 },
		{ lng: -6.2971401, lat: 36.5308554 },
		{ lng: -6.2967002, lat: 36.5308177 },
		{ lng: -6.2963301, lat: 36.5306054 },
		{ lng: -6.2960485, lat: 36.5303414 },
		{ lng: -6.295689, lat: 36.5299302 },
		{ lng: -6.2954248, lat: 36.5297333 },
		{ lng: -6.2950929, lat: 36.5295411 },
		{ lng: -6.2945501, lat: 36.5296519 },
		{ lng: -6.2932849, lat: 36.5297644 },
		{ lng: -6.2930279, lat: 36.52984 },
		{ lng: -6.292839, lat: 36.5298208 },
		{ lng: -6.2925045, lat: 36.5295363 },
		{ lng: -6.2916251, lat: 36.5292292 },
		{ lng: -6.2914563, lat: 36.5291791 },
		{ lng: -6.2912794, lat: 36.5290592 },
		{ lng: -6.2903112, lat: 36.5286965 },
		{ lng: -6.2897667, lat: 36.5282241 },
		{ lng: -6.2891511, lat: 36.5281302 },
		{ lng: -6.2888782, lat: 36.5277157 },
		{ lng: -6.2888115, lat: 36.5274115 },
		{ lng: -6.288978, lat: 36.5270288 },
		{ lng: -6.2888828, lat: 36.526623 },
		{ lng: -6.288441, lat: 36.526253 },
		{ lng: -6.2880985, lat: 36.5258437 },
		{ lng: -6.2875629, lat: 36.526081 },
		{ lng: -6.2867377, lat: 36.5253731 },
		{ lng: -6.2858319, lat: 36.5237308 },
		{ lng: -6.2850541, lat: 36.5232534 },
		{ lng: -6.2826347, lat: 36.5199835 },
		{ lng: -6.2802154, lat: 36.5178279 },
		{ lng: -6.2793024, lat: 36.5166297 },
		{ lng: -6.2790494, lat: 36.5160799 },
		{ lng: -6.2784804, lat: 36.513992 },
		{ lng: -6.2796389, lat: 36.5135754 },
		{ lng: -6.2790138, lat: 36.5124746 },
		{ lng: -6.2786946, lat: 36.512594 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-25T15:00",
			latlng: [36.51251, -6.27858]
		},
		{
			name: "Nueva",
			hora: "2018-03-25T18:35",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-25T19:35",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-25T20:35",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-25T21:00",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-25T21:10",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Colegio Salesianos San Ignacio",
			"Avenida María Auxiliadora",
			"Poeta Nieto",
			"Avda. de Andalucía",
			"Plaza de la Constitución",
			"Cuesta de las Calesas",
			"Plocia",
			"Plaza San Juan de Dios",
			"Avda. 4 de diciembre de 1977",
			"Sánchez Barcaiztegui",
			"San Francisco (izq)",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Avda. 4 de diciembre de 1977",
			"Sánchez Barcaiztegui",
			"San Francisco (izq.)",
			"Nueva",
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pío XII",
			"Estación de Penitencia en la S.I.C"
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Barrié"],
		[
			"Plaza Topete",
			"Compañía",
			"Plaza Pío XII",
			"Pelota",
			"Plaza San Juan de Dios",
			"Sopranis",
			"Compás de Santo Domingo",
			"Perla de Cádiz",
			"Cuesta de las Calesas",
			"Plaza de la Constitución",
			"Avda. Bahía Blanca",
			"Acacias",
			"Brunete",
			"García de Sola",
			"Avda. García Carrera",
			"Escalzo",
			"Avda. María Auxiliadora",
			"Colegio Salesianos"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/despojado.js